import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Breadcrumb, Form } from 'antd';
import { Link } from 'react-router-dom';
import CallbackModal from '../../../../components/CallbackModal';

import TncForm from '../../components/TncForm/TncForm.form.component';

import allBillersRoute from '../../route';

import text from './TncCreate.page.translation';

const FormTncCreate = Form.create()(TncForm);

class TncCreate extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalCallbackVisible: false,
      isCreateSuccess: false,
      tncValue: {
        name: '',
        fileVersion: `V1_${moment().format('DDMMYYYY')}`,
        content: {
          en: '',
          id: '',
        },
      },
    };
  }

  renderBreadCrumb = () => (
    <div className="breadcrumb-wrapper">
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={allBillersRoute.TNC_LIST}>
            {this.props.intl.formatMessage(text.list)}
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          {this.props.intl.formatMessage(text.create)}
        </Breadcrumb.Item>
      </Breadcrumb>
    </div>
  );

  onSubmit = value => {
    this.props.createTnC(value, this.onCallbackSubmit);
  };

  onCallbackSubmit = status => {
    this.setState({
      modalCallbackVisible: true,
      isCreateSuccess: status === 'success',
    });
  };

  redirectDetail = publicID => () => {
    const redirect = allBillersRoute.TNC_DETAIL.replace(':id', publicID);
    this.props.history.replace(redirect);
  };

  onCloseModal = () => {
    const { detail } = this.props;
    this.setState(
      {
        modalCallbackVisible: false,
      },
      this.redirectDetail(detail.public_id),
    );
  };

  render() {
    return (
      <div className="main-content tnc-list">
        {this.renderBreadCrumb()}

        <div className="white-box-wrapper">
          <FormTncCreate
            currentValue={this.state.tncValue}
            intl={this.props.intl}
            onSubmit={this.onSubmit}
            loading={this.props.loading}
          />
        </div>
        <CallbackModal
          modalVisible={this.state.modalCallbackVisible}
          type={this.state.isCreateSuccess ? 'success' : 'error'}
          onClose={this.onCloseModal}
          btnText="Close"
          description={`Create Terms & Conditions ${
            this.state.isCreateSuccess ? 'Success' : 'Failed'
          }`}
        />
      </div>
    );
  }
}

TncCreate.propTypes = {
  intl: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  createTnC: PropTypes.func,
  detail: PropTypes.object,
  history: PropTypes.object,
};

export default TncCreate;
